import React, { Component } from 'react';
import ProgressBar from '../../artzu-ui/src/ProgressBar';

class PromotionDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    const { promoGoal, hoursDriven, hoursBooked, promotionMessage, rules, header, media } = this.props;
    const bookedProgress = hoursBooked * 100 / promoGoal;
    const driveProgress = hoursDriven * 100 / promoGoal;
    return (
      <div className="promo-details">
        {media === 'desktop' ? <p style={{ fontSize: '23px', fontWeight: '600' }}>{header}</p> : null}
        <div className="promo-row">
          <div className="hours-completed">
            <h3 className="large-font">{hoursDriven}</h3>
            <p>Hours Completed</p>
          </div>
          <div className="hours-booked">
            <h3 className="large-font">{hoursBooked}</h3>
            <p>Hours Booked</p>
          </div>
        </div>
        <div className="progress-display">
          <ProgressBar
            fillers={[
              bookedProgress === 0 ? 0 : Math.max(Math.min(bookedProgress, 100), 12),
              driveProgress === 0 ? 0 : Math.max(Math.min(driveProgress, 100), 12),
            ]}
            className="promo-pbar"
            borderColor="#414141"
            primaryColor="#414141"
            secondaryColor="#128dff"
          />
          <p>
            {hoursBooked}/{promoGoal}
          </p>
        </div>
        <p className="promo-desc">{promotionMessage}</p>
        {rules}
      </div>
    );
  }
}

export default PromotionDetail;



// WEBPACK FOOTER //
// ./src/components/Promotion/PromotionDetail.js